<template>
  <ConfirmationModal
    bodyText=""
    cancelText=""
    headerText="No policies applied"
  >
    <template v-slot:message>
      <p>
        You need to apply at least one policy to this policy group first.
        Return to the Policies tab to apply one.
      </p>
    </template>
  </ConfirmationModal>
</template>
<script>
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';

export default {
  name: 'ConfigurationGroupTemplateModal',

  components: {
    ConfirmationModal,
  },

  props: {
  },
};
</script>

<style module>
  @value ( jcInformationalBase ) from '~css/brand-colors.css';

  .details.details {
    margin: 50px 0 20px 0;
  }

  .listItem {
    margin-bottom: 20px;
  }

  .emphasize {
    color: jcInformationalBase;
  }
</style>
